<template>
<div v-loading="isLoading">
  <button
    @click="handleCommand()"
    class="btn btn-primary btn-fill btn-wd "
    title="Este botão irá adicionar o ID do evento aos registros de lâmpadas que não contenham."
  >
    Alterar tags dos eventos, de STRING para _ID
  </button>
  <el-progress :percentage="progressPercentage"/>
</div>
</template>

<script>
import swal from 'sweetalert2'
import CouchdbClass from 'src/services/CouchdbClass'

export default {
  name: 'ChangeEventsTagNameToTagId',
  data () {
    return {
      isLoading: false,
      progress: 0,
      total: 0,
      events: [],
      tags: {}
    }
  },
  computed: {
    couchdbEvents: function () {
      return new CouchdbClass({ connection: 'default', collection: 'events' })
    },
    couchdbTags: function () {
      return new CouchdbClass(({ connection: 'config', collection: 'tags' }))
    },
    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      return parseInt((this.progress / this.total) * 100)
    }
  },
  methods: {
    async handleCommand () {
      this.isLoading = true
      this.total = 0
      this.progress = 0
      try {
        this.events = await this.getEvents()
        this.tags = await this.getTags()
        this.total = this.events.length
        this.isLoading = false

        if (this.total === 0) {
          return this.notifyFinish()
        }
        this.notifyAmount().then(() => this.exec().then(() => {
          this.notifyFinish()
        }).catch(e => console.log('Falha no processo', e)))
      } catch (e) {
        console.log(e)
        this.isLoading = false
      }
    },
    async exec () {
      for (let eventIterator in this.events) {
        const event = this.events[eventIterator]
        event.tags = this.setTagIds(event.tags)
        this.events[eventIterator] = event
        this.progress++
        break
      }
      this.couchdbEvents._postBulkDocs(this.events)
    },
    notifyAmount () {
      return swal({
        title: 'Eventos',
        html: `As tags serão modificadas em ${this.total} eventos. Deseja continuar?`,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, pode modificar!',
        cancelButtonText: 'Não, cancele isso!',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    },
    notifyFinish () {
      this.total = 1
      this.progress = 1
      swal({
        title: 'Sucesso',
        text: `Todas os eventos foram modificados`,
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },
    getEvents () {
      return this.couchdbEvents.where('tags', { '$exists': true }).get()
    },
    getTags () {
      return this.couchdbTags
        .select(['_id', 'name'])
        .get()
        .then(result => {
          return result.reduce((accumulated, currentValue) => {
            if (!accumulated.hasOwnProperty(currentValue.name)) {
              accumulated[currentValue.name.toLowerCase()] = currentValue._id
            }
            return accumulated
          }, {})
        })
    },
    setTagIds (tags) {
      const idTags = []
      for (let tag of tags) {
        if (!this.tags.hasOwnProperty(tag.toLowerCase())) {
          continue
        }
        idTags.push(this.tags[tag.toLowerCase()])
      }
      return idTags.length > 0 ? idTags : tags
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/commands/ChangeEventsTagNameToTagId.vue